import { Injectable } from '@angular/core'
import { Store } from '../../../shared/models/store'
import { ChantierDTO } from '../../../shared/data-access/http/dto/chantier-dto'

export interface CoreStateModel {
    searchedChantiers: ChantierDTO[]
    selectedChantier: ChantierDTO
    isChantierParametre: boolean
}

@Injectable({ providedIn: 'root' })
export class CoreState {
    store = new Store<CoreStateModel>({
        searchedChantiers: [],
        selectedChantier: null,
        isChantierParametre: false,
    })

    static readonly getSearchedChantiers = (state: CoreStateModel): ChantierDTO[] => state.searchedChantiers
    static readonly getIsChantierParametre = (state: CoreStateModel): boolean => state.isChantierParametre
    static readonly getSelectedChantier = (state: CoreStateModel): ChantierDTO => state.selectedChantier
}
